const getDefaultState = () => {
    return {
        fullname     : "",
        nationalityId: 0,
        nationality  : "",
        dob          : "",
        occupation   : "",
        gender       : "",
        mobileCountryId    : 0,
        mobileCountryIdd   : "",
        mobileNum    : "",
        tncagree     : "",
        password     : "",
        password2    : "",
        crn          : 0,
        email        : "",
        pageState    : "",
        refNo        : 0,
        referral     : "",
        recaptcha    : "",
        recaptchaV2  : "",
        singpassUrl  : "",
        emailId      : "",
        emailEVC     : "",
        isSkipAlias  : false,
        singpassEmail: "",
        isAxsr       : false,
        axsIsRegisterError  : false,
        axsRegisterErrorMsg : "",
        isAxsRegisterIdExist: false,
        isAxsCrn            : false,
        isAxsSingpassToken : false,
        isSkipPartnerValidation : false,
    }
}
const state = getDefaultState()

const getters = {
  tnc: (state) => {
    return state.tnc
  },
  singpassUrl: (state) => {
    return state.singpassUrl
  },
  emailId: (state) => {
    return state.emailId
  },
  emailEVC: (state) => {
    return state.emailEVC
  },
  mobileNum: (state) => {
    return state.mobileNum
  },
  mobileCountryId: (state) => {
    return state.mobileCountryId
  },
  mobileCountryIdd: (state) => {
    return state.mobileCountryIdd
  },
  email: (state) => {
    return state.email
  },
  isSkipAlias: (state) => {
    return state.isSkipAlias
  },
  singpassEmail: (state) => {
    return state.singpassEmail
  },
  isAxsr: (state) => {
    return state.isAxsr
  },
  axsIsRegisterError: (state) => {
    return state.axsIsRegisterError
  },
  axsRegisterErrorMsg: (state) => {
    return state.axsRegisterErrorMsg
  },
  isAxsRegisterIdExist: (state) => {
    return state.isAxsRegisterIdExist
  },
  isAxsCrn: (state) => {
    return state.isAxsCrn
  },
  isAxsSingpassToken: (state) => {
    return state.isAxsSingpassToken
  },
  isSkipPartnerValidation: (state) => {
    return state.isSkipPartnerValidation
  }
}

const actions = {
  resetRegistrationState ({ commit }) {
      commit('resetRegistrationState')
  },
  async getTnc({ commit }, data) {
    console.log(data.appId);
    console.log(data.raId);
    const tnc = await this.$api.registration.getTnc(data.appId, data.raId);
    commit('loadTNC', tnc);
  },
  setSingpassUrl({ commit }, value) { 
    commit('setSingpassUrl', value);
  },
  setReferral({ commit }, value) { 
    commit('setReferral', value);
  },
  setEmailId({ commit }, value) { 
    commit('setEmailId', value);
  },
  setEmailEVC({ commit }, value) { 
    commit('setEmailEVC', value);
  },
  setMobileNum({ commit }, value) { 
    commit('setMobileNum', value);
  },
  setMobileCountryId({ commit }, value) { 
    commit('setMobileCountryId', value);
  },
  setEmail({ commit }, value) { 
    commit('setEmail', value);
  },
  setIsSkipAlias({ commit }, value) { 
    commit('setIsSkipAlias', value);
  },
  setIsAxsr({ commit }, value) { 
    commit('setIsAxsr', value);
  },
  setAxsIsRegisterError({ commit }, value) { 
    commit('setAxsIsRegisterError', value);
  },
  setAxsRegisterErrorMsg({ commit }, value) { 
    commit('setAxsRegisterErrorMsg', value);
  },
  setIsAxsRegisterIdExist({ commit }, value) { 
    commit('setIsAxsRegisterIdExist', value);
  },
  setIsAxsCrn({ commit }, value) { 
    commit('setIsAxsCrn', value);
  },
  setIsAxsSingpassToken({ commit }, value) { 
    commit('setIsAxsSingpassToken', value);
  },
  setIsSkipPartnerValidation({ commit }, value) { 
    commit('setIsSkipPartnerValidation', value);
  },
}

const mutations = {
  resetRegistrationState (state) {
      Object.assign(state, getDefaultState())
      console.log("DONE RESET REGISTRATION STORE")
  },
  loadTNC(state, tnc) {
    state.tnc = tnc;
  },
  setSingpassUrl(state, payload){
      state.singpassUrl = payload
  },
  setReferral(state, payload){
      state.referral = payload
  },
  setEmailId(state, payload){
      state.emailId = payload
  },
  setEmailEVC(state, payload){
      state.emailEVC = payload
  },
  setMobileNum(state, payload){
      state.mobileNum = payload
  },
  setMobileCountryId(state, payload){
      state.mobileCountryId = payload.id;
      state.mobileCountryIdd = payload.idd;
  },
  setEmail(state, payload){
    state.email = payload
  },
  setIsSkipAlias(state, payload){
    state.isSkipAlias = payload
  },
  setIsAxsr(state, payload){
    state.isAxsr = payload
  },
  setAxsIsRegisterError(state, payload){
    state.axsIsRegisterError = payload
  },
  setAxsRegisterErrorMsg(state, payload){
    state.axsRegisterErrorMsg = payload
  },
  setIsAxsRegisterIdExist(state, payload){
    state.isAxsRegisterIdExist = payload
  },
  setIsAxsCrn(state, payload){
    state.isAxsCrn = payload
  },
  setIsAxsSingpassToken(state, payload){
    state.isAxsSingpassToken = payload
  },
  setIsSkipPartnerValidation(state, payload){
    state.isSkipPartnerValidation = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}